export default "__VITE_ASSET__ByCMbAPz__"